<script>
    import Router from "svelte-spa-router";
    import Home from "./pages/Home.svelte";
    import Contact from "./pages/Contact.svelte";
    import NotFound from "./pages/NotFound.svelte";
    import NavBar from "./components/layout/NavBar.svelte";
    import Menu from "./components/layout/Menu.svelte";
    import Footer from "./components/layout/Footer.svelte";

    import { isOpenMenu, theme } from './store.js';
    
    $theme === 'dark_theme' ? document.documentElement.className = 'dark_theme' : '';   
    $: { 
        $isOpenMenu ? document.body.className = 'overflow_hidden' : document.body.className = ''; 
    }
</script>

<Menu />

<main class="p-relative { $isOpenMenu ? 'blur' : '' }">
    <NavBar />

    <Router routes={{
        '/': Home,
        '/contact': Contact,
        '*': NotFound,
    }} />

    <Footer />
</main>

<style>
    main{
        min-height: 100vh;
        padding-bottom: 80px;
    }
    @media screen and (max-width: 353px) {
        main{
            padding-bottom: 110px;
        }
    }
</style>